<template>
  <div class="import-orders-detail" v-loading="orderLoading">
    <div class="order-step">
      <div class="el-steps el-steps--horizontal">
        <div class="el-step is-horizontal is-center" style="flex-basis: 25%;" v-for="(obj,idx) in orderTrack" :key="idx">
          <div class="el-step__head " :class="{'is-finish': (obj.status || obj.createDate) && !obj.isClose}">
            <div class="el-step__line"></div>
            <div class="ab-icon is-text">
              <div class="el-step__icon-inner">
                <ab-svg :name="obj.icon"></ab-svg>
              </div>
            </div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title" :class="{'is-finish': (obj.status || obj.createDate) && !obj.isClose}">{{obj.name}} <span v-if="obj.isClose && obj.key == 'wait_pay_exchange'">(已关闭)</span></div>
            <div class="el-step__description" >{{obj.createDate}}</div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="order-number" v-if="dataForm.custOrderNo">NO: {{dataForm.custOrderNo}}</div>
    <detailEdit 
      v-if="isEdit && isFlag"
      :dataForm="dataForm"
      :bizType="bizType"
      :trustee="trustee"
      :cqList="typeList.creditRequirement"
      :payMentTerm="typeList.payMentTerm"
      :typeList="typeList"
      :protocolData="protocolData"
      ref="detailEdit"
      :copyId="routeQuery.copy"
      :cityData="cityData"
      :isTaxPayment="isTaxPayment"
      :deleteArr="deleteArr"
      @collback="collback"
      @isChangeLimit="isChangeLimit"
      @setUploadParams="setUploadParams"
      @autoSave="autoSave"
      @aiSuccess="aiSuccess"
      v-loading="isloading"
    ></detailEdit>

    <detailView 
     :dataForm="dataForm"
     @checkedUpload="checkedUpload"
    v-if="isView"></detailView>

    <ab-upload
        v-if="isUpload"
        :params="uploadParams"
        @update-billsId="updateBillsId"
        ref="fileUpload"
        :disabled="isView"
        popover="PI /INVOICE /PL"
    >
    <template #title>
      <h5>
        供应商发票<i>*</i> / 箱单等
      </h5>
    </template>
  </ab-upload>

    <discount
      :dataForm="dataForm"
      @updatedInfo="updatedInfo"
      v-if="!isView"
      ref="discount"
    >
    </discount>
    <div style="height: 30px;"></div>
    <ab-footer  v-if="!isView">
      <el-button 
      @click="collback"
      >返回</el-button>
      <el-button 
      :loading="btnLoading"
      v-if="dataForm.clientStatus == 1 || dataForm.clientStatus == 4 || !dataForm.clientStatus"
      @click="handlerSave"
      >保存</el-button>
      <el-button 
      v-if="dataForm.clientStatus == 1 || dataForm.clientStatus == 4 || !dataForm.clientStatus"
      type="primary"
      :loading="btnLoading"
      @click="handlerSubmit">提交</el-button>
      <el-button
        :loading="btnLoading"
        v-if="
          [2].includes(dataForm.clientStatus) &&
            dataForm.deliveryIsBatchDelivery &&
            dataForm.isLocked
        "
        @click="getInitNewFromEntrust"
        :disabled="dataForm.totalCanDeliveredQty <= 0"
        type="primary"
        >创建发货通知</el-button>

        
        

    </ab-footer>
    <ab-footer  v-else>
      <el-button
          :loading="btnLoading"
          v-if="[2].includes(dataForm.clientStatus)"
          type="primary"
          @click="handlerRevoke"
          >修改</el-button
        >
      <el-button 
      @click="collback"
      >返回</el-button>

      <ab-continue-sign
          :show="dataForm.clientStatus == 5 && dataForm.signatureStatus == '02'"
          billType="01"
          :customerBillNumber="dataForm.custOrderNo"
          @handleClose="signClose"
        >
          继续签章
        </ab-continue-sign>
        <ab-revoke-sign
          :billId="dataForm.id"
          buttonType=""
          :show="dataForm.clientStatus == 5 && dataForm.signatureStatus == '02'"
          :url="'/oms/client/entrustImport/revokeFlow'"
          @callback="revokeCallback"
          >撤回签章</ab-revoke-sign
        >
      </ab-footer>
    <ab-preview :preview="preview" @handleClose="handleClose">
      <template slot="button">
        <el-button @click="handleClose">关 闭</el-button>
      </template>
    </ab-preview>
    <el-dialog v-model="sumbitDialog.show" :show-close="false"  width="500px" center>
      <template #header="{ close, titleId, titleClass }">
        <div class="sub-dialog-header">
          <h4 :id="titleId" :class="titleClass">温馨提示</h4>
          <div @click="handlerSubClose">
            <ab-svg name="my-off"></ab-svg>
          </div>
        </div>
      </template>
      <div class="sub-content">
        <img src="@/assets/img/success.png"/>
        <div>提交成功！</div>
        <div>订单编号为：{{this.dataForm.custOrderNo}}</div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handlerSubClose">暂不付汇</el-button>
          <el-button type="primary" :loading="subDialogLoading" @click="handlerSubApp">
            立即付汇
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      v-model="overdueData.visible"
      :close-on-click-modal='false'
      width="500px">
      <div>
        <!-- <icon-svg name="gantanhao" style="float: left; width: 24px; margin-right: 15px"></icon-svg> -->
       
        <span style="width: calc(100% - 40px); font-size: 14px; display: inline-block; margin: 10px"> <el-icon style="color: #e7c053;font-size: 20px;float:left;"><WarningFilled /></el-icon>{{overdueData.message}}</span>
      </div>
      <el-form ref="overdue-form" :model="overdueData" >
        <el-form-item class="backDate" prop="backDate" :rules="[{required: dataForm.isTaxesAdvanced, message: '若选择垫税，请提供预计付款日期！', trigger: 'blur'}]">
          <el-date-picker
            size="mini"
            v-model="overdueData.backDate"
            :picker-options="pickerOptions"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            type="date"
            placeholder="请选择预计付款日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="overdueData.visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSubmit">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import detailEdit from './import-detail-edit.vue'
import detailView from './import-detail-view.vue'
import discount from './discount.vue'
import { h } from 'vue'
export default {
  name: 'import-orders-detail',
  components: {
    detailEdit,
    detailView,
    discount
  },
  data () {
    return {
      isFlag: false,
      orderTrack: [
        {
          status: 0,
          name: '订单提交',
          createDate: '',
          icon: 'order-tijiao',
          key: "submitted"
        },
        {
          status: 0,
          name: '付汇',
          createDate: '',
          icon: 'fuhui',
          key: "pay_exchange"
        },
        {
          status: 0,
          name: '付费',
          createDate: '',
          icon: 'fufei',
          key: "paid_fee"
        },
        {
          status: 0,
          name: '完成',
          createDate: '',
          icon: 'wancheng',
          key: "complete"
        }
      ],
      routeQuery: {},
      dataForm: {
        id: ''
      },
      bizType: [], // 业务类型
      trustee: [], // 供应链公司枚举
      cityData: [],
      typeList: {
        packingTypeList: [], // 包装种类下拉框
        quarantineList: [], // 检验检疫条件下拉框
        supervisionList: [], // 监管条件下拉框
        creditRequirement: [], // 资金需求
        deliveryPayType: [], // 交货付费方式
        entrustPayMethod: [], // 付款方式
        fastMailServiceLocation: [], // 快递送达地点
        incomingPayType: [], // 来货付费方式
        payMentTerm: [], // 成交方式
        serviceLocation: [], // 送达地点
        signatureMode: [], // 签收方式
        infoWriteTiming: [] //交货信息
      },
      protocolData: [],
      princpalName: '',
      preview: {
        show: false,
        isView: false,
        isAgree: true,
        isFooter: true,
        fileUrl: ""
      },
      btnLoading: false,
      uploadParams: {
        coreBillIds: "",
        coreBillNumbers: "",
        sourceBillId: "",
        sourceBillNumber: "",
        sourceBillType: "EntrustAll",
        billsType: "",
        items: []
      },
      sumbitDialog: {
        show: false
      },
      subDialogLoading: false,
      freeVoPercent: {},
      isUpload: true,
      sendType: false,
      orderLoading: false,
      overdueData: {
        visible: false,
        message: '',
        backDate: ''
      },
      pickerOptions: {
            // 限制预约时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      isloading: false,
      signature: false
    }
  },
  created() {
  },
  mounted() {
    this.getList()
    this.getTypeList() // 订单明细枚举
    this.getclientGetDDL()
    this.getBasAreaList()
    let userInfo = this.$utils.getSessionStorage('userInfo') || {}
    this.princpalName = userInfo.companyName
    setTimeout(() => {
      this.isFlag = true
    }, 50)
  },
  computed: {
    isTaxPayment: {
      get() {
        if (this.protocolData.length) {
          // if (
          //   this.protocolData[0].taxPayment &&
          //   !this.routeQuery.id
          // ) {
            
          // }
          return this.protocolData[0].taxPayment
        } else {
          return false
        }
      }
    },
    sidebarFold: {
      get () {
          return this.$store.state.sidebarFold
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.mainTabs
      },
      set(val) {
        this.$store.commit('updateMainTabs', val)
      }
    },
    mainTabsActiveName: {
        get () { return this.$store.state.mainTabsActiveName },
        set (val) { this.$store.commit('updateMainTabsActiveName', val) }
    },
    isEdit () {
      if(this.dataForm.clientStatusDesc && this.dataForm.clientStatusDesc != '已保存' && this.dataForm.clientStatusDesc != '已退回') {
        return false
      } else if (!this.routeQuery.status || this.routeQuery.status == 'add' || this.dataForm.clientStatusDesc == '已保存' || this.dataForm.clientStatusDesc == '已退回' ||  this.routeQuery.status == 'copy') {
        return true
      } else {
        return false
      }
    },
    isView () {
      if (this.dataForm.clientStatusDesc && this.dataForm.clientStatusDesc != '已保存' && this.dataForm.clientStatusDesc != '已退回') {
        return true
      } else {
        return false
      }
    }
  },
  activated () {
    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    if (
      typeof this.routeQuery.cache === "string"
        ? JSON.parse(this.routeQuery.cache)
        : this.routeQuery.cache
    ) {
      return false
    } else {
      this.routeQuery.cache = true
    }
    if (this.routeQuery.status === "add" || !this.routeQuery.status) {
      
      this.dataForm.id = ''
      this.dataForm.entry = []
      this.getRelatePrincipal()
      this.resetTrack()
      setTimeout(() => {
        this.$refs.detailEdit.$refs.dataForm.clearValidate()
        this.$refs.detailEdit.$refs.ordersDetail.$refs.dataForm.clearValidate()
      }, 3000)
    } else if (this.routeQuery.copy) {
      this.dataForm.id = ''
      this.dataForm.entry = []
      this.$refs.fileUpload.resetData()
      this.copyCreated()
      this.resetTrack()
    } else if (this.routeQuery.id) {
      this.getEntrustImport(this.routeQuery.id, "isHasFlow")
    }
  },
  methods: {
    resetTrack () {
      this.orderTrack.map(e => {
        e.status = 0
        e.createDate = ''
      })
    },
    getList () {
      this.$get('/wmsbase/repertory/findRepertoryList', {pageSize: 999, pageNum: 1, isInToStore: 1}).then(({ data }) => {
        if (data && data.code === 'C0000') {
            this.typeList.storehouse = data.result.list
        }
      })
    },
    getTypeList() {
      this.$get("/oms/entrustImport/typeList").then(res => {
        if (res.data && res.data.code === "C0000") {
          let data = res.data.result
          this.typeList.packingTypeList = data.packingTypeList
          this.typeList.quarantineList = data.quarantineList
          this.typeList.supervisionList = data.supervisionList
        }
      });
    },
    getclientGetDDL() {
      this.$get("/oms/client/entrustImport/clientGetDDL").then(res => {
        if (res.data && res.data.code === "C0000") {
          this.typeList = Object.assign(this.typeList, res.data.result)
        }
      })
    },
    getBasAreaList() {
      this.$post("/bas/basArea/list", { isEnabled: 1, type: 3 }).then(
        ({ data }) => {
          if (data && data.code === "C0000") {
            if (data.result && data.result[0].children) {
              this.cityData = data.result[0].children
            }
          }
        }
      )
    },
    getRelatePrincipal () {
      this.$get("/oms/client/entrustImport/getRelatePrincipal")
        .then(res => {
          if (res.data.code === "C0000") {
            let principalId = res.data.result ? res.data.result.id : ''
            if (!principalId) {
              this.$message.error('系统异常未获取到委托方信息，请刷新后重试！')
            }
            this.dataForm = {
              principalId: principalId,
              exchangeUnitType: "1",
              bizType: '',
              entry: [
                {
                  _$index: new Date().getTime(),
                  model: '',
                  brand: '',
                  materialName: '',
                  baseUnitId:"2942674771050496",
                  baseUnitName:"个",
                  packingMaterial: '22',
                  productSpec: '',
                  originPlaceName: '',
                  originPlaceId: '',
                  qty: '',
                  price: '',
                  amount: '',
                  packedQty: '',
                  netWeight: '',
                  grossWeight: '',
                  custMatNo: '',
                  importTariffRate: ''
                }
              ],
              deliveryIsBatchDelivery: false,
              costEstimate: {
                isUseAcc: ''
              }
            }
            
            // this.$set(this.dataForm, "entry", [{}]); //默认送货到香港锦盛仓
            this.dataForm.supplierMethod = "01" //默认送货到香港锦盛仓
            let hisImport = this.$utils.getHisOrderData("hisImport", this.princpalName)
            if (hisImport && hisImport.supplierName) {
              this.dataForm.supplierName = hisImport.supplierName
              this.dataForm.supplierId = hisImport.supplierId
              this.dataForm.currencyName = hisImport.currencyName
              this.dataForm.currencyId = hisImport.currencyId
              this.dataForm.payTimePoint = hisImport.payTimePoint
              this.dataForm.supplierMethod = hisImport.supplierMethod
              this.dataForm.supplierMethodLabel = hisImport.supplierMethodLabel
            }

            this.uploadParams = {
              coreBillIds: "",
              coreBillNumbers: "",
              sourceBillId: "",
              sourceBillNumber: "",
              sourceBillType: "EntrustAll",
              billsType: "",
              items: []
            }
            this.dataForm.exchangeUnitType = "1"
            let date = new Date()
            this.dataForm.bizDate =
              date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
            this.dataForm.expectedDeclareDate = this.dataForm.bizDate //预计报关日期等于下单日期
           
            this.getSameAsPrincipal()
            this.servProtocolList()
            this.checkCustomerHasFlow()
            this.setUploadParams()
            this.getByNumber() // 采购组织
            this.getPrincipalIntegral()
          } else {
            this.$message.error('功能异常，请刷新页面，重新试试！')
          }
        })
        .finally(e => {})
    },
    getSameAsPrincipal() {
      this.$post("/bas/basCustomer/getSameAsPrincipal", {
        principalId: this.dataForm.principalId
      }).then(res => {
        if (res.data.code === "C0000" && res.data.result) {
          this.dataForm.customerId = res.data.result.id
          this.dataForm.customerName = res.data.result.name
          this.dataForm.exchangeUnitId = res.data.result.id
          this.dataForm.exchangeUnitName = res.data.result.name
        }
      })
    },
    servProtocolList(state) {
      this.protocolLoading = true
      let queryData = this.dataForm.bizDate
      if (this.dataForm.clientStatusDesc == '已保存') {
        let date = new Date()
        queryData =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate()
      }
      
      this.$post("/bas/client/servProtocol/list", {
        entrustId: this.dataForm.principalId,
        isEnable: 1,
        queryDate: queryData,
        typeList: ["01", "02"],
        status: "03"
      })
        .then(res => {
          if (
            res.data &&
            res.data.code === "C0000" &&
            res.data.result.length !== 0
          ) {
            this.setProtocolData(res.data.result)
            if (res.data.result.length === 1 || state == "edit") {
              //只有一条协议，调用基础信息中协议处理方法，设置默认值
              setTimeout(() => {
                if (this.$refs.detailEdit) {
                  this.$refs.detailEdit.changeProtocol("init");
                }
              }, 100);
            }
            this.protocolData = res.data.result
            this.getFreeVoPercent(this.protocolData[0])
          } else if (res.data && res.data.code === "C0000") {
            this.$message({
              type: 'error',
              message: "未查询到对应的服务协议",
              offset: 380,
              grouping: true,
            })
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.protocolLoading = false
          }, 20)
        })
    },
    setProtocolData(data) {
      let bizTypeTemp = []
      let trusteeTemp = []
      data.map(e => {
        // 从协议中取业务类型，然后去重
        let bizTypeTempType = false
        if (bizTypeTemp.length > 0) {
          bizTypeTemp.map(b => {
            if (b.type === e.type) {
              bizTypeTempType = true
            }
          })
          if (!bizTypeTempType) {
            bizTypeTemp.push({
              type: e.type,
              typeDesc:
                e.type == "01" ? "13% 增值税专用发票" : "海关税票+6%服务费发票"
            })
          }
        } else {
          bizTypeTemp.push({
            type: e.type,
            typeDesc:
              e.type == "01" ? "13% 增值税专用发票" : "海关税票+6%服务费发票"
          })
        }

        // 从协议中取供应链公司，然后去重
        let trusteeTempType = false
        if (trusteeTemp.length > 0) {
          trusteeTemp.map(b => {
            if (b.type === e.trusteeId) {
              trusteeTempType = true
            }
          });
          if (!trusteeTempType) {
            trusteeTemp.push({ type: e.trusteeId, typeDesc: e.trusteeName })
          }
        } else {
          trusteeTemp.push({ type: e.trusteeId, typeDesc: e.trusteeName })
        }
      });
      this.bizType = bizTypeTemp
      if (this.bizType.length === 1) {
        // 协议只带出一条业务类型，默认自动选中
        this.dataForm.bizType = this.bizType[0].type
      }
      this.trustee = trusteeTemp
      if (this.trustee.length === 1) {
        // 协议只带出一条供应链公司，默认自动选中
        this.dataForm.trusteeId = this.trustee[0].type
      }
    },
    getFreeVoPercent(protocolData) {
      if (!protocolData.taxPayment) {
        return false
      }
      this.$get("/bas/platformAmount/getFreeVoPercent", {
        principalId: this.dataForm.principalId,
        trusteeId: this.dataForm.trusteeId,
        bizType: this.dataForm.bizType
      }).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.dataForm.applyStatus = data.result.applyStatus
          this.dataForm.taxFree = data.result.taxFree
          this.dataForm.taxAmount = data.result.taxAmount
          this.dataForm.taxIsEnabled = data.result.taxIsEnabled
          this.dataForm.taxFreeNot = "额度已禁用"
          this.dataForm.taxDisableReason =  data.result.taxDisableReason || ""

          this.freeVoPercent.applyStatus = data.result.applyStatus
          this.freeVoPercent.taxFree = data.result.taxFree
          this.freeVoPercent.taxAmount = data.result.taxAmount
          this.freeVoPercent.taxIsEnabled = data.result.taxIsEnabled
          this.freeVoPercent.taxFreeNot = "额度已禁用"
          this.freeVoPercent.taxDisableReason = data.result.taxDisableReason || ""

          if (typeof this.dataForm.isTaxesAdvanced != 'number') { //用户没有操作垫税 才要默认
              //委托方有垫税和垫税额度，默认勾选
            this.dataForm.isTaxesAdvanced = this.dataForm.taxFree && this.dataForm.taxIsEnabled ? 1 : 0
          }

          if (!this.dataForm.id && this.dataForm.taxIsEnabled && this.dataForm.taxFree <= 0 && this.dataForm.applyStatus != 2) {
            this.$confirm('当前垫税可用额度已不足，是否现在提高垫税额度?','温馨提示', {
                confirmButtonText: '立即提额',
                cancelButtonText: '暂不提额',
                type: 'warning'
            }).then(() => {
                this.$refs.detailEdit.handlerLimit()
            })
          }
        }
      })
    },
    checkCustomerHasFlow() {
      this.$get("/sys/esignAccount/checkCustomerAccount").then(res => {
        if (res.data && res.data.code === "C0000") {
          this.signature = res.data.result
          let isHasFlow = this.$utils.getLocalStorage("isHasFlow", "1")
          if (isHasFlow || res.data.result) {
            return false
          }

          this.$confirm(res.data.message, '温馨提示', {
                confirmButtonText: '立即认证',
                cancelButtonText: '暂不认证',
                type: 'warning'
            }).then(() => {
              this.$router.push({
                path: 'my-signature',
                query: {
                  type: '01'
                }
              })
            })
          
          // let notfiy = this.$notify({
          //   dangerouslyUseHTMLString: true,
          //   iconClass: "m-icon",
          //   customClass: "custom-message",
          //   duration: 10000,
          //   position: "bottom-right",
          //   title: "温馨提示！",
          //   message: h("div", null, [
          //     h(
          //       "div",
          //       { class: "notify-text", style: "word-break: break-all;" },
          //       res.data.message
          //     ),
          //     h("div", { class: "notify-button" }, [
          //       h(
          //         "button",
          //         {
          //           onClick:  () => {
          //             this.$utils.setLocalStorage("isHasFlow", "1")
          //             notfiy.close()
          //           },
          //           class: "el-button el-button--default el-button--small"
          //         },
          //         "忽略"
          //       ),
          //       h(
          //         "button",
          //         {
          //           onClick: () => {
          //             this.$router.push({
          //               path: "/my-signature"
          //             })
          //             notfiy.close()
          //           },
          //           class: "el-button el-button--default el-button--small el-button--primary"
          //         },
          //         "详情"
          //       )
          //     ])
          //   ])
          // })
        }
      })
    },
    setUploadParams() {
      this.uploadParams.coreBillIds = this.dataForm.id
      this.uploadParams.coreBillNumbers = this.dataForm.custOrderNo
      this.uploadParams.sourceBillId = this.dataForm.id
      this.uploadParams.sourceBillNumber = this.dataForm.custOrderNo
      
      let items = []
      // 境内交互，客户自提
      if (this.dataForm.deliveryMethod == "01") {
        items = [
          {
            title: "供应商发票",
            attachType: "040",
            required: true,
            message: "PI/INVOICE"
          },
          {
            title: "供应商箱单",
            attachType: "050",
            required: false,
            message: "PL"
          },
          {
            title: "进口货物确认单",
            attachType: "010",
            required: false
          },
          {
            title: "其他资料",
            attachType: "990",
            required: false,
            message: "如：规格书、到货通知等"
          }
        ]
      } else {
        items = [
          {
            title: "供应商发票",
            attachType: "040",
            required: true
          },
          {
            title: "供应商箱单",
            attachType: "050",
            required: false
          },
          {
            title: "进口货物确认单",
            attachType: "010",
            required: false
          },
          {
            title: "其他资料",
            attachType: "990",
            required: false
          }
        ]
      }
      this.uploadParams.items = items
    },
    getByNumber() {
      // 采购组织默认
      this.$get("/p/organization/getByNumber", { number: 2020 }).then(
        ({ data }) => {
          if (data && data.code === "C0000") {
            this.dataForm.purOrgName = data.result.name
            this.dataForm.purOrgId = data.result.id
            this.dataForm.offshoreOrgName = data.result.name
            this.dataForm.offshoreOrgId = data.result.id
          }
        }
      )
    },
    collback () {
      let flag = this.destroyPage()
      if (!flag) {
        this.removeTabHandle(this.menuActiveName);
      }
    },
    updatedInfo (data) {
      this.dataForm.costEstimate = data
    },
    validata (type) {
      let refs = [
        this.$refs.detailEdit.$refs.dataForm,
        this.$refs.detailEdit.$refs.domesticDelivery,
        this.$refs.detailEdit.$refs.ordersDetail
      ]
      if (type != 'save') {
        refs.push(this.$refs.fileUpload)
      }
      return Promise.all(
        refs.map((item) => {
          return item.validate()
        })
      ).then((list) => {
        return true
      }).catch(e => {
        if (type == 'save') {
          this.$refs.detailEdit.$refs.dataForm.clearValidate()
          this.$refs.detailEdit.$refs.domesticDelivery.$refs.dataForm.clearValidate()
          this.$refs.detailEdit.$refs.ordersDetail.$refs.dataForm.clearValidate()
          return true
        } else {
           return false
        }
      })
    },
    calcEntry () {
      let flag = false
      // for (var i = 0; i < this.dataForm.entry.length; i++) {
      //   if (
      //     parseFloat(this.dataForm.entry[i].netWeight) >
      //     parseFloat(this.dataForm.entry[i].grossWeight)
      //   ) {
      //     this.$message({
      //       type: "error",
      //       message: `货物信息：第${i + 1}条,净重不能大于毛重`,
      //       offset: 380,
      //       grouping: true,
      //     })
      //     flag = true
      //     break
      //   }
      // }
      return flag
    },
    handlerSave () {
      this.btnLoading = true
      if (!this.dataForm.bizType) {
        this.$message({
          type: "error",
          message: `请选择发票类型`,
          offset: 380,
          grouping: true,
        })
        this.btnLoading = false
        this.getScrollIntoView()
        return false
      }
      this.validata('save').then(valid => {
        if (valid) {
          if (this.calcEntry()) {
            this.btnLoading = false
            return false
          }
          this.checkedPrice(this.beforSendData, "save")
        } else {
          this.btnLoading = false
        }
      })
      
    },
    handlerSubmit () {
      this.btnLoading = true
      this.validata('submit').then(valid => {
        if (valid) {
          if (this.calcEntry()) {
            this.btnLoading = false
            return false
          }
          if (!this.signature) {
            this.$confirm('您尚未做个人认证，下单后将无法提交是否现在去认证？', '温馨提示', {
                cancelButtonText: '暂不认证',
                confirmButtonText: '立即认证',
                type: 'warning'
            }).then(() => {
              this.$router.push({
                path: 'my-signature',
                query: {
                  type: '01'
                }
              })
            }).catch(() => {})
            this.btnLoading = false
            return false
          }
          
          if (this.dataForm.supplierMethod == "02") {
            if (!this.dataForm.incomingAddress) {
              this.$message({
                type: "error",
                message: "请填写新增提货需求弹窗信息！",
                offset: 380,
                grouping: true,
              });
              this.btnLoading = false
              return false
            }
          }
          setTimeout(() => {
            if (this.checkedLimit()) {
              if (!this.dataForm.id) {
                this.sendType = true
                this.handlerSave()
              } else {
                this.sendData("submit");
              }
            }
          }, 500)
        } else {
          this.btnLoading = false
          this.getScrollIntoView()
        }
      })
    },
    getScrollIntoView () {
      setTimeout(() => {
        let errObj = document.getElementsByClassName("is-error")
        if (errObj.length) {
          errObj[0].scrollIntoView({
            behavior: "smooth",
            block: "center"
          })
        }
      }, 0)
    },
    checkedLimit() {
      let flag = true
      if (this.dataForm.isTaxesAdvanced) {
        if (!this.freeVoPercent.taxIsEnabled) {
          let str =
            "很抱歉，" + this.freeVoPercent.taxDisableReason + "，请先处理后再下单"
          this.$alert(str, "温馨提示", {
            confirmButtonText: "确定",
            callback: action => {}
          })
          flag = false
        }
      }
      return flag
    },
    checkedPrice(fnc, type) {
      this.preview.show = false;
      let arry = [];
      let isarr = []; //商检集合
      this.dataForm.entry.map((e, i) => {
        if (
          e.increaseFlag ||
          (typeof e.increaseFlag == "number" && !e.increaseFlag)
        ) {
          arry.push(i + 1)
        }
        if (!e.isInspectionDesc || e.isInspectionDesc == "") {
          isarr.push("否")
        } else {
          isarr.push(e.isInspectionDesc)
        }
      })
      fnc(type, Array.from(new Set(isarr)))
    },
    beforSendData(str, arry) {
      if (arry.length > 1) {
        this.$confirm(
          "商检物料需提前做检，不建议和非商检物料合并下单，请单独下单！",
          "提示",
          {
            cancelButtonText: "取消",
            confirmButtonText: "继续下单",
            type: "warning"
          }
        )
          .then(() => {
            this.sendData(str)
          })
          .catch(() => {
            this.btnLoading = false
          })
      } else {
        this.sendData(str)
      }
    },
    sendData(str, fuc) {
      let data = this.setData()
      if (!/^\d+$/.test(Number(this.dataForm.totalPackedQty))) {
        this.$message({
          type: 'error',
          message: "总件数必须为整数，请确认！",
          offset: 380,
          grouping: true,
        })
        this.btnLoading = false
        return false
      }
      let url = "",
        state = ""
      if (this.dataForm.id) {
        url = "/oms/client/entrustImport/mod" // 修改
        state = "edit"
      } else {
        url = "/oms/client/entrustImport/add" // 保存
        state = "add"
        if (this.tempBillId) {
          data.tempBillId = this.tempBillId
        }
      }
      if (str === "submit") {
        url = "/oms/client/entrustImport/clientConfirm" // 提交
        state = str
      }
      this.btnLoading = true
      this.$post(url, data)
        .then(res => {
          if (res.data && res.data.code === "C0000") {
            if (fuc) {
              if (str == "beforSubmit") {
                this.getEntrustImport(res.data.result, "", fuc)
              } else {
                this.getEntrustImport(res.data.result)
                fuc()
              }
              return false
            } else {
              if (str !== "submit") {
                this.$message({
                  type: 'success',
                  message: res.data.message,
                  offset: 380,
                  grouping: true,
                })
              }
            }
            switch (state) {
              case "add":
                this.dataForm.id = res.data.result
                this.getEntrustImport(this.dataForm.id)
                break
              case "edit":
                this.getEntrustImport(this.dataForm.id)
                break
              case "submit":
                if (res.data.result) {
                  this.preview.isView = true
                  this.preview.fileTitle = "货物确认单"
                  this.preview.fileUrl = res.data.result
                  this.preview.show = true
                } else {
                  if (!this.dataForm.deliveryIsBatchDelivery) {
                    this.sumbitDialog.show = true
                  }
                }
                  this.getEntrustImport(this.dataForm.id)
                break
            }
          } else if(res.data.code === 'E0008'){
            this.overdueData.message = res.data.message
            this.overdueData.backDate = ''
            this.overdueData.visible = true
            setTimeout(() => {
              this.$refs['overdue-form'].resetFields()
            }, 50);
          }else{
            this.btnLoading = false
          }
        })
        .finally(() => {
          setTimeout(() => {
            if (str !== "beforSubmit" && !this.sendType) {
              this.btnLoading = false
            }
          }, 500)
        })
    },
    getAmountTotal () {
      return this.dataForm.entry.map(row => row.amount).reduce((acc, cur) => {
          if (!cur) {
            cur = 0
          }
          return this.$calc.add(cur, acc)
      }, 0).toFixed(2)
    },
    getExpectedSum () {
      return this.dataForm.entry.map(row => row.qty).reduce((acc, cur) => {
          if (!cur) {
          cur = 0
          }
          return this.$calc.add(cur, acc)
      }, 0)
    },
    getPackedQtySum () {
      return this.dataForm.entry.map(row => row.packedQty).reduce((acc, cur) => {
          if (!cur) {
          cur = 0
          }
          return this.$calc.add(cur, acc)
      }, 0)  
    },
    getGrossWeightSum (){
      return this.dataForm.entry.map(row => row.grossWeight).reduce((acc, cur) => {
      if (!cur) {
          cur = 0
      }
      return this.$calc.add(cur, acc)
      }, 0)
      
    },
    palletQtySum () {
      return this.dataForm.entry.map(row => row.palletQty).reduce((acc, cur) => {
        if (!cur) {
            cur = 0
        }
        return this.$calc.add(cur, acc)
      }, 0)
    },
    netWeightSum () {
      return this.dataForm.entry.map(row => row.netWeight).reduce((acc, cur) => {
      if (!cur) {
          cur = 0
      }
      return this.$calc.add(cur, acc)
      }, 0)
    },
    getDate (theDate = new Date()) {
      if (!theDate) return theDate
      let date = ''
      if (typeof theDate == 'string') {
        date = new Date(theDate.replace(/-/g,'/'))
      } else {
        date = new Date(theDate)
      }
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + this.double(month) + '-' + this.double(day)
    },
    double (date) {
      if (date < 10) {
        date = '0' + date
      }
      return date
    },
    setData() {
      this.dataForm.totalQty = this.getExpectedSum() || '' // 总数量
      this.dataForm.totalGrossWeight =  this.getGrossWeightSum() || ''
      this.dataForm.totalPackedQty = this.getPackedQtySum() || ''
      this.dataForm.totalPalletQty = this.palletQtySum() || '' // 总卡板
      this.dataForm.totalAmount = this.getAmountTotal() || '' //总金额
      this.dataForm.totalNetWeight = this.netWeightSum() || ''
      this.dataForm.bizDate = this.getDate(this.dataForm.bizDate) || ""
      this.dataForm.domesticOrgName = this.dataForm.trusteeName || "" // 境内收货人=受托方=供应链公司
      this.dataForm.domesticOrgId = this.dataForm.trusteeId || ""
      this.dataForm.payTimePoint = 0
      
      let data = Object.assign({}, this.dataForm) || ""
      data.isHkCustomsClearance =  this.dataForm.supplierMethod=='06' && this.dataForm.supplierMethodAddressId && this.dataForm.supplierMethodAddressId.length && this.dataForm.supplierMethodAddressId[1] != '4794175053496320' ? 1 : 0;
      if (data.incomingAreaId) {
        data.incomingAreaId = data.incomingAreaId.join(",")
      }
      if (data.deliveryAreaId) {
        data.deliveryAreaId = data.deliveryAreaId.join(",")
      }
      if (data.supplierMethodAddressId) {
        data.supplierMethodAddressId = data.supplierMethodAddressId.join(",")
      }
      if (this.$refs.detailEdit && this.$refs.detailEdit.$refs.ordersDetail) {
        let deleteArr = this.$refs.detailEdit.$refs.ordersDetail.deleteArr
        if (deleteArr && deleteArr.length) {
          data.entry = this.dataForm.entry.concat(deleteArr)
        }
      }
      
      if (this.$refs.detailEdit.$refs.domesticDelivery.$refs.abHistory) {
        this.$refs.detailEdit.$refs.domesticDelivery.$refs.abHistory.setHistory(
          this.dataForm.principalName,
          this.dataForm.deliveryIdentityNumber
        )
      }

      this.$utils.setHisOrderData("hisImport", {
        supplierName: this.dataForm.supplierName,
        supplierId: this.dataForm.supplierId,
        currencyName: this.dataForm.currencyName,
        currencyId: this.dataForm.currencyId,
        supplierMethod: this.dataForm.supplierMethod,
        supplierMethodLabel: this.dataForm.supplierMethodLabel,
        isTaxesAdvanced: this.dataForm.isTaxesAdvanced,
        payTimePoint: this.dataForm.payTimePoint
      }, this.princpalName)
      return data;
    },
    handleClose() {
      this.preview.show = false
      setTimeout(() => {
        this.getEntrustImport(this.dataForm.id, null, null, 'seal')
      }, 1000)
    },
    updateBillsId(billsId) {
      this.tempBillId = billsId
    },
    collback () {
      let flag = this.destroyPage()
      if (!flag) {
        this.removeTabHandle(this.mainTabsActiveName)
      }
    },
    removeTabHandle(tabName) {
      this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
      if (tabName) {
        this.$router.push({ path: "/import-orders-list" })
      }
    },
    destroyPage () {
      let flag = false
      if (!this.dataForm.number) {
        this.$confirm("订单还未保存，是否直接关闭？", "温馨提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          this.removeTabHandle(this.mainTabsActiveName);
        }).catch(() => {
          
        })
        flag = true
      }
      return flag
    },
    getPrincipalIntegral() {
      this.$get("/oms/principalIntegral/get").then(({ data }) => {
        if (data.result) {
          this.nowMoney = data.result.nowMoney || 0
          if (!this.dataForm.costEstimate) {
            this.dataForm.costEstimate = {}
          }
          if (this.nowMoney > 0) {
            this.dataForm.costEstimate.isUseAcc = true
          }
        }
      })
    },
    getEntrustImport(id, state, fuc, sealType) {
      this.orderLoading = true
      return this.$get("/oms/client/entrustImport/get", { id: id }).then(res => {
        if (res.data && res.data.code === "C0000") {
          
          this.dataForm = res.data.result
          this.dataForm.costEstimate.couponId = res.data.result.costEstimate.couponId || 0;
          this.dataForm.isHkCustomsClearance = !!this.dataForm.isHkCustomsClearance
          if (typeof this.dataForm.incomingAreaId === "string") {
            let address1 = this.dataForm.incomingAreaId.split(",")
            this.dataForm.incomingAreaId = []
            if (address1.length > 0) {
              address1.map(e => {
                this.dataForm.incomingAreaId.push(e)
              })
            }
          }
          if (typeof this.dataForm.deliveryAreaId === "string") {
            let address2 = this.dataForm.deliveryAreaId.split(",")
            this.dataForm.deliveryAreaId = []
            if (address2.length > 0) {
              address2.map(e => {
                this.dataForm.deliveryAreaId.push(e)
              })
            }
          }
          if (typeof this.dataForm.supplierMethodAddressId === "string") {
            let address2 = this.dataForm.supplierMethodAddressId.split(",")
            this.dataForm.supplierMethodAddressId = []
            if (address2.length > 0) {
              address2.map(e => {
                this.dataForm.supplierMethodAddressId.push(e)
              })
            }
          }
          this.getOrderStatusDetail()
          
          if (state === "isHasFlow") {
            this.checkCustomerHasFlow()
          }
          if (sealType && sealType == 'seal' && this.dataForm.clientStatus == 2) { //签章通过，订单提交
           this.sumbitDialog.show = true
          }
          this.setUploadParams()
          this.servProtocolList("edit")
          if (this.sendType) {
            this.sendData("submit");
          }
          if (fuc) {
            this.dataForm.estimateTaxesAmount =
              res.data.result.estimateTaxesAmount
            fuc()
            return false
          }
        }
      }).finally(() => {
        setTimeout(() => {
          this.orderLoading = false
          this.sendType = false
        }, 50)
      })
    },
    copyCreated() {
      this.isloading = true
      this.$get("/oms/client/entrustImport/copyCreate", {
        id: this.routeQuery.copy
      }).then(res => {
        if (res.data && res.data.code === "C0000") {
          this.tempBillId = ""
          let obj = this.dataForm.costEstimate
          this.dataForm = res.data.result
          this.dataForm.costEstimate = obj
          if (this.dataForm.entry.length > 0) {
            this.dataForm.entry.map((e, i) => {
              e._$index = "create-" + i
            });
          }
          if (typeof this.dataForm.incomingAreaId === "string") {
            let address1 = this.dataForm.incomingAreaId.split(",")
            this.dataForm.incomingAreaId = [];
            if (address1.length > 0) {
              address1.map(e => {
                this.dataForm.incomingAreaId.push(e)
              });
            }
          }
          if (typeof this.dataForm.deliveryAreaId === "string") {
            let address2 = this.dataForm.deliveryAreaId.split(",")
            this.dataForm.deliveryAreaId = [];
            if (address2.length > 0) {
              address2.map(e => {
                this.dataForm.deliveryAreaId.push(e)
              });
            }
          }
          if (typeof this.dataForm.supplierMethodAddressId === "string") {
            let address2 = this.dataForm.supplierMethodAddressId.split(",")
            this.dataForm.supplierMethodAddressId = [];
            if (address2.length > 0) {
              address2.map(e => {
                this.dataForm.supplierMethodAddressId.push(e)
              })
            }
          }
          this.setUploadParams()
          this.servProtocolList("edit")
          this.checkCustomerHasFlow()
          this.getPrincipalIntegral()
        }
      }).finally(() => {
        setTimeout(() => {
          this.isloading = false
        }, 1000)
      })
    },
    getInitNewFromEntrust () {
      let flag = false
      if (!this.dataForm.bizType) {
        this.$message({
          type: 'error',
          message: "业务类型不能为空！",
          offset: 380,
          grouping: true,
        })
        flag = true
      }
      if (this.dataForm.entry && this.dataForm.entry.length > 0) {
        this.dataForm.entry.map(e => {
          if (
            !e.brand ||
            !e.model ||
            !e.materialName ||
            !e.qty ||
            !e.originPlaceName ||
            !e.baseUnitId
          ) {
            this.$message({
              type: 'error',
              message: "物料明细：品牌，型号，品名，数量，产地，单位不能为空！",
              offset: 380,
              grouping: true,
            })
            flag = true
            return false
          }
        })
      }
      if (flag) {
        return false
      }
      this.btnLoading = true;
      this.$post("/tms/client/sendNotice/queryWaitPageList", {
        custOrderNo: this.dataForm.custOrderNo
      })
        .then(res => {
          if (
            res.data.code === "C0000" &&
            res.data.result &&
            res.data.result.list.length > 0
          ) {
            this.$router.push({
              path: "/delivery-notice-detail",
              query: {
                action: "add",
                list: res.data.result.list,
                source: "orders",
                cache: false
              }
            })
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.btnLoading = false
          }, 500)
        })
    },
    revokeCallback() {
      setTimeout(() => {
        this.collback()
      }, 200)
    },
    handlerRevoke() {
      this.$confirm('确定要修改吗?修改后需要重新提交，请谨慎操作！', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
      }).then(() => {
        this.btnLoading = true
        this.$get("/oms/client/entrustImport/clientRevoke", {
          id: this.dataForm.id
        })
        .then(res => {
          if (res.data && res.data.code === "C0000") {
            this.$message({
              type: 'success',
              message: res.data.message,
              offset: 380,
              grouping: true,
            })
            this.getEntrustImport(this.dataForm.id).then(() => {
              this.$refs.discount.getCouponEntry()
            })
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.btnLoading = false
          })
        })
      }).catch(() => {})
      
    },
    signClose () {
      this.getEntrustImport(this.dataForm.id)
    },
    getOrderStatusDetail () {
      this.$get('/oms/client/entrustImport/getOrderStatusDetail', {id: this.dataForm.id}).then(({data}) => {
        if (data && data.code == 'C0000') {
          
          let track = data.result.result
          if (track && track.length) {
            this.orderTrack.map(e => {
              if (e.key == data.result.currentStatusPath) {
                e.status = 1
              } else {
                e.status = 0
              }
              track.map(y => {
                if (e.key == y.key) {
                  e.createDate = y.date
                }
              })
            })
          }
        }
      })
    },
    isChangeLimit (protocol) {
      this.getFreeVoPercent(protocol)
    },
    handlerSubClose () {
      this.sumbitDialog.show = false
      this.collback()
    },
    handlerSubApp () {
      this.subDialogLoading = true
      let orderData = this.$_.cloneDeep(this.dataForm)
      this.$post('/sms/client/paymentPayable/toPayByBill2', [orderData.id]).then(({ data }) => {
      if (data && data.code === 'C0000') {
          data.result.paymentAppBackVoList = data.result.paymentAppBackVoList || []
          data.result.paymentAppCustomsVoList = data.result.paymentAppCustomsVoList || []
          data.result.paymentAppGeneralEntryVoList = data.result.paymentAppGeneralEntryVoList || []
          data.result.paymentAppPayVoList = data.result.paymentAppPayVoList || []
          data.result.paymentAppPreEntrustVoList = data.result.paymentAppPreEntrustVoList || []
          data.result.paymentAppRevVoList = data.result.paymentAppRevVoList || []
          data.result.paymentAppSumAmountVos = data.result.paymentAppSumAmountVos || []
          this.sumbitDialog.show = false
          this.$router.push({
          path: '/pledging-payment-detail',
          query: {
              action: 'import',
              result: JSON.stringify(data.result),
              cache: false,
              edit: true
          }
          })
        
      } else {
        this.$message({
          type: 'error',
          message: data.message,
          offset: 380,
          grouping: true,
        })
      }
      }).finally(() => {
        this.sumbitDialog.show = false
        this.subDialogLoading = false
       
      })
    },
    checkedUpload (val) {
      if (val == '01') {
        this.isUpload = true
      } else {
        this.isUpload = false
      }
    },
    // 自动保存
    autoSave() {
      let data = this.setData()
      let url = ''
      if (data.id) {
        url = '/oms/client/entrustImport/mod'
      } else {
        url = '/oms/client/entrustImport/add'
      }
      this.$post(url, data).then(({ data }) => {
          if (data && data.code === 'C0000') {
          this.getEntrustImport(data.result, '', () => {
              this.$refs.detailEdit.$refs.ordersDetail.aiMakeOrderFn(this.dataForm)
          })
          }
      })
    },
    confirmSubmit() {
      this.$refs['overdue-form'].validate((valid) => {
        if(valid){
          this.overdueData.visible = false
          this.dataForm.skip = true
          this.dataForm.backDate = this.overdueData.backDate
          this.sendData('submit')
        }
      })
    },
    aiSuccess () {
      this.getEntrustImport(this.dataForm.id)
    }
  }
};
</script>

<style lang="scss">
.import-orders-detail {
   position: relative;
  .order-step {
    padding: 30px;
    margin: 0 8%;
    .ab-icon {
      .el-step__icon-inner {
        padding: 13px 16px;
        height: 64px;
        width: 64px;
        background-color: #F2F7FF;
        border-radius: 8px;
      }
      .icon-svg {
        width: 33px;
        height: 36px;
      }
    }
    .el-step__line {
      left: 55%;
      right: -41%;
      margin: 20px;
      background:none;
      width: 100%;
      height: 2px;
      background-image: linear-gradient(to right, rgb(214, 214, 214) 0%, rgb(214, 214, 214) 50%, transparent 50%);
      background-size: 15px 1px;
    }
    .el-step__title {
    
      font-weight: 500;
    }
    
  }
  .order-number {
      height: 35px;
      line-height: 35px;
      background-color: #f2f7ff;
      border-radius: 0 0 8px 8px;
      width: 225px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      top: 0;
      right: 0px;
    }
  .coupons{
    display: flex;
    margin-bottom: 20px;
    .el-form-item{
      margin-right: 30px;
    }
  }
  .footer {
    padding: 20px;
    text-align: center;
  }
  .cargoInfo {
   
  }
  .sub-dialog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .icon-svg {
      height: 19px;
      width: 19px;
    }
  }
  .sub-content {
    text-align: center;
    
    div {
      font-size: 16px;
      line-height: 24px;
      color: #000000;
    }
  }
  .receivingAddress {
    .icon-svg {
      width: 11px;
      height: 16px;
      vertical-align: bottom;
    }
  }
}
</style>
